import request from 'configuration/request';
import { httpBuildQuery } from 'helpers/utils';

export const rejectReasonApi = {
  getList: () => {
    return request({
      url: '/reject_reason/list/',
      method: 'GET',
    });
  },
  create: (data) => {
    return request({
      url: '/reject_reason/create/',
      method: 'POST',
      data,
    });
  },
};
